import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function Statistic() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [statistic, setStatistic] = useState({
    mitra: "",
    produk: "",
    transaksi_harian: "",
    mitra_perhari: "", 
  });

  const [videoFile, setVideoFile] = useState(null);
  const [videoFileWhyUs, setVideoFileWhyUs] = useState(null);

  const onChangeStatistic = (e) => {
    const { name, value } = e.target;

    setStatistic((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeWhyUsVideo = (e) => {
    const file = e.target.files[0];

    if (file) {    
      setVideoFileWhyUs(file);
    }
  };

  const fetchStatistic = async () => {

    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/statistic/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setStatistic(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };

  useEffect(() => {
    fetchStatistic();
  }, []);

  const updateStatistic = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // append text fields
      formData.append("mitra", statistic.mitra);
      formData.append("produk", statistic.produk);
      formData.append("transaksi_harian", statistic.transaksi_harian);
      formData.append("mitra_perhari", statistic.mitra_perhari);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/statistic/1`,
        {
          method: "POST",
          body: formData, // 
        }
      );

      if (!res.ok) throw new Error("Gagal update");

      const result = await res.json();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Statistik berhasil diperbarui!",
        showConfirmButton: false,
        timer: 3000,
      });

    } catch (err) {
      Swal.fire("Error", "Gagal update data", "error");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="min-h-screen bg-white text-white">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 pt-40 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-600  to-[#3E3274] bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600  to-[#3E3274] mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-white"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                Section Statistik Radar
              </div>
              <div className='flex flex-row'>
                <div className='w-1/4 p-4'>
                  <label className="block mb-1 font-medium ">Mitra</label>
                  <input
                    type="text"
                    name="mitra"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={statistic?.mitra}
                    onChange={onChangeStatistic}
                    required
                  />
                </div>
                <div className='w-1/4 p-4'>
                  <label className="block mb-1 font-medium ">Produk</label>
                  <input
                    type="text"
                    name="produk"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={statistic?.produk}
                    onChange={onChangeStatistic}
                    required
                  />
                </div>
                <div className='w-1/4 p-4'>
                  <label className="block mb-1 font-medium ">Transaksi Harian</label>
                  <input
                    type="text"
                    name="transaksi_harian"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={statistic?.transaksi_harian}
                    onChange={onChangeStatistic}
                    required
                  />
                </div>
                <div className='w-1/4 p-4'>
                  <label className="block mb-1 font-medium ">Mitra Perhari</label>
                  <input
                    type="text"
                    name="mitra_perhari"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={statistic?.mitra_perhari}
                    onChange={onChangeStatistic}
                    required
                  />
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={updateStatistic} className='p-4 rounded-full bg-gradient-to-r from-red-600  to-[#3E3274] hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Simpan</button>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </section>
      
    </div>
  );
}

export default Statistic;
